"use strict";
import { MENU_ITEMS_ORDER, NAV_ITEMS } from "./consts";
import { config } from "./state";

export const toggleActiveMenuItem = menuItem => {
  const { activeMenuItems } = config;
  const { hash } = menuItem;
  config.updated = true;
  if (activeMenuItems.has(hash)) {
    activeMenuItems.delete(hash);
  } else {
    activeMenuItems.add(hash);
  }
};

export const getCategoryHash = () => {
  if (
    config.isSpecialsFirstPage &&
    config.activeMenuItems.has(NAV_ITEMS.SPECIALS.hash)
  ) {
    return NAV_ITEMS.SPECIALS.hash;
  }
  const menuItem = MENU_ITEMS_ORDER.find(item =>
    config.activeMenuItems.has(item.hash)
  );
  return menuItem?.hash || "";
};
